import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavController, IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import {
    AccountProfileService, FirestorePathsService, DealershipService, FirebaseFunctionsService, UsersService
} from '@shared/services';
import { ViewBasePage } from '@shared/pages';
import { MyPhonePipe, MyTimestampPipe } from '@shared/pipes'
import type { TAccountProfile, TAccountStatus, TTimestamp, TDealership } from '@shared/models';

@Component({
    'selector': 'app-accountProfile',
    'templateUrl': './accountProfile.page.html',
    'styleUrls': ['./accountProfile.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule, MyPhonePipe, MyTimestampPipe  ]
})
export class AccountProfilePage extends ViewBasePage implements OnInit, OnDestroy {
    public dealership: TDealership;
    public accountProfile: TAccountProfile;
    public allManagers: string;
    private dateRangeStart: TTimestamp;
    private dateRangeEnd: TTimestamp;

    constructor(private activatedRoute: ActivatedRoute, private accountProfileService: AccountProfileService,
        private firestorePathsService: FirestorePathsService, private dealershipService: DealershipService,
        private navController: NavController, private usersService: UsersService,
        injector: Injector) {
        super(injector);
    }

    public override async ngOnInit(): Promise<void> {
        try {
            const uid = this.activatedRoute.snapshot.paramMap.get('uid');
            const accountNumber = uid.replace(/'/g, '');
            if (!accountNumber) {
                return;
            }
            this.dealership = await this.dealershipService.getDealershipByAccountNumber(accountNumber);
            this.accountProfile = await this.accountProfileService.getAccountProfileByAccountNumber(accountNumber);
            // const users: TUser[] = await this.usersService.getUsersByAccountNumber(accountNumber);
            // const managers = users.filter(user => user.role === 'Manager');
            // const managerNames = managers.map(user =>
            //     user.firstName + ' ' + user.lastName + ' [' + user.email + ']'
            // );
            // this.allManagers = managerNames.join(', ');

            // Expiration Date
            const now = this.dateService.now();
            this.dateRangeStart = this.dateService.add(now, -2, 'months');
            this.dateRangeEnd = this.dateService.add(now, 2, 'months');

            // Hosting Expiration Date
            this.dateRangeStart = this.dateService.add(now, -2, 'months');
            this.dateRangeEnd = this.dateService.add(now, 2, 'months');
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            await this.uxHelperService.showAlert('Error', errorMessage);
        }
    }

    public override ngOnDestroy() {
        super.ngOnDestroy();
    }

    public getPremiumSupportExpirationDate(): any {
        const timestamp = this.accountProfile?.periodInfo.premiumSupportExpirationDate;

        const str = this.dateService.timestampToUTC(timestamp);
        return str;
    }

    public async onStatusClick() {
        const statii: TAccountStatus[] = ['Active', 'In Trial Period', 'Cancelled By Support', 'Cancelled By Customer',
            'Trial Period Expired', 'Package Expired'];
        const response = await this.uxHelperService.showRadioAlert('Select Account Status', statii, this.accountProfile.status);
        if (response.okay) {
            this.accountProfile.status = response.selectedItems[0] as TAccountStatus;
            await this.uxHelperService.showToastWithCloseButton('Expiration date may need to be updated.');
        }
    }

    // public getPhoneNumberFormatted() {
    //     if (!this.accountProfile) {
    //         return null;
    //     }
    //     const phone = this.utilsService.formatPhoneNumberForDisplay(this.dealership.phoneNumber);
    //     return phone;
    // }

    public async onExpirationDateClick() {
        // this.accountProfile.periodInfo.expirationDate =
        //     await this.openCalendarModal(this.dateRangeStart, this.dateRangeEnd,
        //         this.accountProfile.periodInfo.expirationDate, 'Select Expiration Date');

        const response: any = await this.openCalendarModal(this.dateRangeStart, this.dateRangeEnd,
            this.accountProfile.periodInfo.expirationDate, 'Select Expiration Date');

        if (response.data.okay) {
            this.accountProfile.periodInfo.expirationDate = this.dateService.toTimestamp(response.data.selectedItems[0]);
        }
    }

    public async onPremiumSupportExpirationDateClick() {
        // this.accountProfile.periodInfo.premiumSupportExpirationDate =
        //     await this.openCalendarModal(this.dateRangeStart, this.dateRangeEnd,
        //         this.accountProfile.periodInfo.premiumSupportExpirationDate,
        //         'Select Premium Support Expiration Date');

        const response: any = await this.openCalendarModal(this.dateRangeStart, this.dateRangeEnd,
            this.accountProfile.periodInfo.premiumSupportExpirationDate,
            'Select Premium Support Expiration Date');

        if (response.data.okay) {
            this.accountProfile.periodInfo.premiumSupportExpirationDate =
                this.dateService.toTimestamp(response.data.selectedItems[0]);
        }
    }

    public async onHostingExpirationDateClick() {
        const response: any = await this.openCalendarModal(this.dateRangeStart, this.dateRangeEnd,
            this.accountProfile.periodInfo.webHostingExpirationDate,
            'Select Hosting Expiration Date');

        if (response.data.okay) {
            this.accountProfile.periodInfo.webHostingExpirationDate =
                this.dateService.toTimestamp(response.data.selectedItems[0]);
        }
    }

    public async onSaveClick() {
        await this.uxHelperService.showSpinner('Saving.');

        // if (this.selectedExpirationDateFormatted) {
        //     this.firebaseFunctionsService.updateExpirationDateCount(this.accountProfile.accountNumber);
        // }

        try {
            this.firestorePathsService.setAccountNumber(this.accountProfile.accountNumber);
            await this.accountProfileService.update(this.accountProfile);
            this.navController.back();
            this.uxHelperService.showToast('Saved.');
        } catch (err) {
            await this.uxHelperService.showAlert('Error', JSON.stringify(err));
        } finally {
            this.uxHelperService.hideSpinner();
        }
    }
}
